export default "__VITE_ASSET__FRWVvpeS__"